"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFile = void 0;

var http_1 = require("./http");

var uri = "/v5/files/";

function default_1(uuid, credentials) {
  return http_1.authorizedHTTP(credentials).get(uri + uuid.string()).then(function (resp) {
    return resp.data;
  });
}

exports.default = default_1;
/** createFile
 *
 *  - filename - straight forward filename of the file to upload, remember to include the ending to let the software know what it is
 *  - path - a "virtual" directory path, it is preferable to keep the directory structure flat so use e.g. user and not pictures/install/
 *  - content - the file content as base64 encoded
 *
 */

exports.createFile = function (filename, path, content, uuid, credentials) {
  return http_1.authorizedHTTP(credentials).post(uri + uuid.string(), {
    "name": filename,
    "path": path,
    "content": content
  });
};